import { render } from "./SuggestFavoriteSpotsList.vue?vue&type=template&id=e4fb496c&scoped=true"
import script from "./SuggestFavoriteSpotsList.vue?vue&type=script&lang=js"
export * from "./SuggestFavoriteSpotsList.vue?vue&type=script&lang=js"

import "./SuggestFavoriteSpotsList.vue?vue&type=style&index=0&id=e4fb496c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4fb496c"]])

export default __exports__